import reducer, { initialState } from './core/providers/reducer';
import React, { useEffect, useState } from 'react';
import User from './types/User';
import Subscription from './types/Subscription';
import {
    AppFaviconUrl,
    billingDisabled,
    GLOBAL_REDIRECT_URL,
    WRONG_GLOBAL_REDIRECT_URL,
} from './core/CcxEnv';
import useDataStores from './core/hooks/useDataStores';
import UsersService from './services/UsersService';
import BillingService from './services/BillingService';
import { StateProvider } from './core/providers/StateProvider';
import { SubscriptionContext } from './core/context/SubscriptionContext';
import { UserContext } from './core/context/UserContext';
import { VpcsProvider } from './core/providers/VpcsProvider';
import { ChartsProvider } from './core/providers/ChartsProvider';
import { DeploymentsContext } from './core/context/DeploymentsContext';

type AppProvidersProps = {
    children: React.ReactNode;
};
export default function AppProviders({ children }: AppProvidersProps) {
    const [user, setUser] = useState<User | undefined>(undefined);
    const [subscription, setSubscription] = useState<Subscription | undefined>(
        undefined
    );

    //setting favicons
    let icons: any = [];
    if (document) {
        icons = document.querySelectorAll(
            'link[rel=icon],[rel=apple-touch-icon]'
        );
    }

    if (icons.length) {
        icons.forEach(function (i: any) {
            i.href = AppFaviconUrl;
        });
    }

    // redirect for if users on lintasarta try to access dbaas.cloudeka.id instead of cmd.cloudeka.id
    if (WRONG_GLOBAL_REDIRECT_URL && GLOBAL_REDIRECT_URL) {
        let wrongUrl =
            window.location !== window.parent.location
                ? document.referrer
                : document.location.href;

        if (wrongUrl.startsWith(WRONG_GLOBAL_REDIRECT_URL)) {
            window.parent.location.href = GLOBAL_REDIRECT_URL;
        }
    }

    // @TODO: remove the hard-coded default here, added for compatibility while transitioning
    // into the "project & data store" concept for ccx-37
    const { dataStores: deployments, refresh } = useDataStores('default');
    // @TODO: continue to refactor into app state
    // const [{ deployment }, dispatch] = useAppState();

    // check user session
    useEffect(() => {
        const checkUser = async () => {
            const logged = await UsersService.check();
            setUser(logged);

            if (!billingDisabled) {
                const sub = await BillingService.checkUserSubscription();
                setSubscription(sub);
            }
        };

        if (!user) {
            checkUser();
        }
    }, []);

    useEffect(() => {
        const AUTO_REFRESH_INTERVAL = 60000;
        const interval = setInterval(async () => {
            if (!billingDisabled) {
                const sub = await BillingService.checkUserSubscription();
                setSubscription(sub);
            }
        }, AUTO_REFRESH_INTERVAL);

        return () => clearInterval(interval);
    }, [subscription]);

    return user ? (
        <StateProvider initialState={initialState} reducer={reducer}>
            <UserContext.Provider value={{ user: user, setUser: setUser }}>
                <SubscriptionContext.Provider value={subscription}>
                    <VpcsProvider>
                        <ChartsProvider>
                            <DeploymentsContext.Provider
                                value={{ deployments, refresh }}
                            >
                                {children}
                            </DeploymentsContext.Provider>
                        </ChartsProvider>
                    </VpcsProvider>
                </SubscriptionContext.Provider>
            </UserContext.Provider>
        </StateProvider>
    ) : (
        <></>
    );
}
